// extracted by mini-css-extract-plugin
export default {"stack":"DriverOutOfHoursReplacementStep_stack__XhtTn","replacementBox":"DriverOutOfHoursReplacementStep_replacementBox__fd6ri"};